import { PerksScreen } from 'app/features/perks/screen'
import { GetServerSideProps } from 'next'
import { withAuthedPage } from '../../lib/session'
import { createTiersQuery, mapToTiers } from 'app/queries/tiers/member-tiers'
import { createPerksQuery, mapPerks } from 'app/queries/perks/perks'
import { dehydrate, QueryClient } from 'react-query'
import { makeQuery } from 'app/hooks/use-query'

export default PerksScreen

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async (context) => {
    const store = context.req?.userStore

    const queryClient = new QueryClient()
    const tiersQuery = createTiersQuery()
    const perksQuery = createPerksQuery()

    await Promise.all([
      queryClient.prefetchQuery(['query', tiersQuery, {}], async () => {
        return makeQuery(tiersQuery, {}, mapToTiers, store)
      }),
      queryClient.prefetchQuery(['query', perksQuery, {}], async () => {
        return makeQuery(perksQuery, {}, mapPerks, store)
      }),
    ])

    const dehydratedState = dehydrate(queryClient)

    return {
      props: {
        dehydratedState,
      },
    }
  },
)
